

var _angular = require('angular');

var _angularAria = require('angularAria');

// Configure angular aria.
// Note that aria configuration applies globally
_angularAria.$ariaProvider.config({ // eslint-disable-line angular/di
    // Remove bindRoleForClick since we use ngClick for several items that shouldn't be treated as buttons.
    bindRoleForClick: false,

    // Remove ariaInvalid and ariaRequired as we want to handle them ourselves.
    // These attributes should only be set once the form is submitted, to match what
    // visually what we display
    ariaInvalid: false,
    ariaRequired: false
});

(0, _angular.$registerDirective)('xo-error-tooltip', function () {

    return {
        restrict: 'A',
        require: ['?^form', '?ngModel'],
        link: function link(scope, element, attrs, ctrls) {
            var formCtrl = ctrls[0],
                modelCtrl = ctrls[1];


            function shouldBeRequired() {
                if (formCtrl) {
                    // If input is a checkbox and has error-text or error-key, show the error text instead of the required text.
                    // error-text is a legacy thing for backward compatibility, we can get rid of this once all teams
                    // adopt error-key in all input tags
                    var showCheckboxRequired = !(element.attr('type') === 'checkbox' && (attrs.errorText || attrs.errorKey));
                    return formCtrl.$submitted && modelCtrl.$error.required && showCheckboxRequired;
                } else {
                    return modelCtrl.$error.required;
                }
            }

            function shouldBeInvalid() {
                if (formCtrl) {
                    return formCtrl.$submitted && modelCtrl.$invalid;
                } else {
                    return modelCtrl.$invalid;
                }
            }

            // Add or remove a string into a space split string (eg. aria-describedby ids, class names)
            function formatSpaceSplitString(str, id, add) {
                var strArray;
                if (str) {
                    strArray = str.split(' ');
                } else {
                    strArray = [];
                }

                var idIndex = strArray.indexOf(id);

                if (~idIndex && !add) {
                    strArray.splice(idIndex, 1);
                } else if (!~idIndex && add) {
                    strArray.push(id);
                }

                return strArray.join(' ');
            }

            // Add tooltip behavior after DOM settles
            (0, _angular.$timeout)(function () {
                var generateId = function generateId() {
                    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 7);
                };

                var requiredId = generateId();
                var invalidId = generateId();
                var requiredError;
                var invalidError;

                if (attrs.errorKey) {
                    element.addClass('hasErrorTooltipRuleSpecific');
                    invalidError = (0, _angular.$compile)('<div class="errorTooltip errorTooltipRuleSpecific" id="' + invalidId + '">{{content("' + attrs.errorKey + '")}}</div>')(scope);
                    element.after(invalidError);
                } else if (attrs.errorText) {
                    // errorText if case is for backward compatibility, we can get rid of this once
                    // all teams adopt error-key in all input tags for tooltip message display
                    element.addClass('hasErrorTooltipRuleSpecific');
                    invalidError = $('<div class="errorTooltip errorTooltipRuleSpecific" id="' + invalidId + '">' + attrs.errorText + '</div>');
                    element.after(invalidError);
                }

                if (attrs.required || (0, _angular.$parse)(attrs.ngRequired)(scope)) {
                    element.addClass('hasErrorTooltipRequired');
                    requiredError = (0, _angular.$compile)('<div class="errorTooltip errorTooltipRequired" id="' + requiredId + '">{{content("validation.required")}}</div>')(scope);
                    element.after(requiredError);

                    element.removeAttr('aria-required');
                }

                function setAriaAttributes() {
                    var addTooltips = {
                        required: false,
                        invalid: false
                    };

                    // Do not associate "Required" error with aria-describedby
                    // because this should already be read out either by "required"
                    // attribute or "aria-required"=true, and only associate "Invalid"
                    // error if "Required" is not showing to match visuals
                    if (shouldBeRequired()) {
                        addTooltips.required = true;
                    } else if (shouldBeInvalid()) {
                        addTooltips.invalid = true;
                    }

                    var describedby = element.attr('aria-describedby');
                    describedby = formatSpaceSplitString(describedby, requiredId, addTooltips.required);
                    describedby = formatSpaceSplitString(describedby, invalidId, addTooltips.invalid);
                    element.attr('aria-describedby', describedby);
                }

                scope.$watch(shouldBeRequired, function (newVal) {
                    setAriaAttributes();
                });
                scope.$watch(shouldBeInvalid, function (newVal) {
                    element.attr('aria-invalid', newVal);
                    setAriaAttributes();
                });

                // Set scroll so that the error message is in view when element receives focus
                element.on('focus', function (event) {
                    var windowBot = $(window).scrollTop() + $(window).height();
                    var requiredBot = requiredError ? requiredError.offset().top + requiredError.outerHeight() : 0;
                    var invalidBot = invalidError ? invalidError.offset().top + invalidError.outerHeight() : 0;
                    if (windowBot < Math.max(requiredBot, invalidBot)) {
                        $(window).scrollTop(Math.max(requiredBot, invalidBot) - $(window).height());
                    }
                });
            });
        }
    };
});

_angular.$registerDirective;

_angular.$parse;

_angular.$compile;

_angular.$timeout;

_angularAria.$ariaProvider;


//////////////////
// WEBPACK FOOTER
// ./components/xo-ui-components/src/error-tooltip/directive.js
// module id = ./components/xo-ui-components/src/error-tooltip/directive.js
// module chunks = 1